module.exports = __webpack_public_path__ + "static/media/vf_wtop_core.75c45ed4.svg";